import {
    Container,
    Grid,
    MenuItem,
    Paper,
    Typography
} from '@material-ui/core';
import { ComplaintInsert as INSERT } from 'Components/Api/ComplaintsAPI';

import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { MaterialSelect } from 'Components/Inputes/FormikMaterialSelect';
import HOCLoader from 'Components/Loader/HOCLoader';
import { LOGOUT } from 'ConstComponents';
import { Form, Formik } from 'formik';
import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router';
import * as Yup from 'yup';
import Divider from '@material-ui/core/Divider';
import {
    PrimaryButton,
    SecondaryButton
} from 'Components/Inputes/CustomButton';
import { SelectBBPSEnabledServices as SERVICE_SELECT } from 'Components/Api/ServiceApi';
import { Select as OPERATOR_SELECT_BY_SERVICEID } from 'Components/Api/OperatorsApi';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import BharatConnect_LOGO from 'Assets/BBPS/BBPS-Horizontal-06.png';

const CustomContainer = HOCLoader(Container);

export const RegisterComplaint = () => {
    const history = useHistory();
    const formRef = useRef();
    const [responseMessage, setResponseMessage] = useState('');
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [Services, setServices] = useState([]);
    const [isComplaintReason, setComplaintReason] = useState([]);
    const [Operator, setOperator] = useState([]);

    const [formObj, setFormObj] = useState({
        ComplaintType: 'Service',
        TransactionMasterID: 0,
        ServiceID: 0,
        MobileNumber: '',
        CustomerRemark: '',
        ComplaintReasonID: 0,
        Description: ''
    });

    const validationSchema = Yup.object({
        ServiceID: Yup.number()
            .required('Service is required.')
            .min(1, 'Please select a valid Service.'),

        MobileNumber: Yup.string()
            .required('Mobile Number is required.')
            .matches(/^[0-9]{10}$/, 'Mobile Number must be 10 digits.'),

        ComplaintReasonID: Yup.number()
            .required('Complaint Reason is required.')
            .min(1, 'Please select a valid Complaint Reason.'),

        TransactionMasterID: Yup.string().required(
            'Transaction ID is required.'
        ),

        Description: Yup.string()
            .required('Description is required.')
            .min(5, 'Description must be at least 10 characters long.')
            .max(500, 'Description cannot exceed 500 characters.')
    });
    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        setSubmitting(false);
        setResponseMessage('');

        const selectedComplaintReason = isComplaintReason.find(
            (item) => item.ComplaintReasonMasterID === values.ComplaintReasonID
        );

        let requestObj = {
            TransactionMasterID: values.TransactionMasterID,
            ServiceID: values.ServiceID,
            ConsumerNumber: values.MobileNumber,
            CustomerRemark: values.Description,
            ComplaintReasonID: values.ComplaintReasonID,
            ComplaintReason: selectedComplaintReason
                ? selectedComplaintReason.ComplaintReason
                : ''
        };

        setLoadingOpen(true);
        const response = await INSERT(JSON.stringify(requestObj));

        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(response.data);

            return;
        }

        setIsError(true);
        setResponseMessage(response.data);
        resetForm();
    };
    const reset = () => {
        setResponseMessage('');
        setFormObj({
            ComplaintType: 'Service',
            TransactionMasterID: 0,
            ServiceID: 0,
            OperatorID: 0,
            MobileNumber: '',
            CustomerRemark: '',
            ComplaintReasonID: 0,
            Description: ''
        });
    };

    useEffect(() => {
        selectServices();
    }, []);

    const selectServices = async () => {
        const response = await SERVICE_SELECT();
        if (!response.isAuthorized) LOGOUT();

        var data = JSON.parse(response.data);
        setServices(data);
    };

    const OnOperatorChange = async (name, value, setFieldValue) => {
        var ServiceID = value; //event.target.value;

        setFieldValue(name, value);

        selectOperator(ServiceID);
    };

    const selectOperator = async (ServiceID) => {
        if (
            ServiceID === null ||
            ServiceID === undefined ||
            ServiceID === 0 ||
            ServiceID === '0'
        )
            return;

        var requestObj = {
            ServiceID: ServiceID
        };
        var request = JSON.stringify(requestObj);

        const response = await OPERATOR_SELECT_BY_SERVICEID(request);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) setIsError(true);

        if (response.data !== 'Requested operators not found') {
            var data = JSON.parse(response.data);
            setOperator(data);
        }
    };
    const TransferForm = ({ values, errors, setFieldValue }) => {
        return (
            <>
                <Grid
                    item
                    sm={12}
                    md={12}
                    lg={12}
                    style={{
                        textAlign: 'right',
                        marginTop: '5px',
                        marginRight: '5px'
                    }}
                >
                    <img
                        src={BharatConnect_LOGO}
                        alt="BharatConnect Logo"
                        style={{
                            maxHeight: '50px'
                        }}
                    />
                </Grid>
                <Paper
                    style={{
                        padding: '30px'
                    }}
                >
                    <Grid container>
                        <Grid item sm={12} md={12} lg={12}>
                            <Grid
                                container
                                spacing={2}
                                style={{
                                    padding: '10px'
                                }}
                            >
                                <Grid item xs={12} sm={12} md={9} lg={9} xl={9}>
                                    <Typography
                                        variant="h4"
                                        component="h1"
                                        gutterBottom
                                    >
                                        Register Complaint
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                                    <PrimaryButton
                                        type="button"
                                        title="Complaint status"
                                        size="small"
                                        onClick={() =>
                                            history.push('/ComplaintStatus')
                                        }
                                    />
                                </Grid>
                            </Grid>
                            <Divider />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <CustomContainer
                                isLoading={loadingOpen}
                                isError={isError}
                                alertMessage={responseMessage}
                                severity={severity}
                                onCloseCallback={(alertState) => {
                                    setIsError(alertState);
                                }}
                            >
                                <Form>
                                    <Grid
                                        spacing={5}
                                        container
                                        style={{
                                            justifyContent: 'center'
                                        }}
                                    >
                                        <Grid
                                            item
                                            xs={4}
                                            sm={4}
                                            md={4}
                                            lg={4}
                                            xl={4}
                                        >
                                            <Grid
                                                container
                                                spacing={2}
                                                sx={{
                                                    justifyContent: 'center'
                                                }}
                                            >
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                    xl={12}
                                                >
                                                    <MaterialTextField
                                                        label="Complaint Type"
                                                        name="ComplaintType"
                                                        type="text"
                                                        length={150}
                                                        title="Complaint Type"
                                                        readOnly={true}
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                    xl={12}
                                                >
                                                    <MaterialSelect
                                                        label="Service Reason"
                                                        name="ServiceID"
                                                        onCustomCallback={(
                                                            name,
                                                            value
                                                        ) => {
                                                            OnOperatorChange(
                                                                name,
                                                                value,
                                                                setFieldValue
                                                            );
                                                        }}
                                                        title="Service"
                                                    >
                                                        <MenuItem
                                                            key="0"
                                                            value="0"
                                                        >
                                                            All Service
                                                        </MenuItem>
                                                        {Services.map(
                                                            (Item) => (
                                                                <MenuItem
                                                                    key={
                                                                        Item.ServiceID
                                                                    }
                                                                    value={
                                                                        Item.ServiceID
                                                                    }
                                                                >
                                                                    {
                                                                        Item.ServiceName
                                                                    }
                                                                </MenuItem>
                                                            )
                                                        )}
                                                    </MaterialSelect>
                                                </Grid>

                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                    xl={12}
                                                >
                                                    <MaterialNumberField
                                                        label="Mobile Number"
                                                        name="MobileNumber"
                                                        type="text"
                                                        length={10}
                                                        title="Mobile Number"
                                                    />
                                                </Grid>

                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialSelect
                                                        label="Complaint Reason"
                                                        name="ComplaintReasonID"
                                                        title="Complaint Reason"
                                                    >
                                                        <MenuItem
                                                            key="0"
                                                            value="0"
                                                        >
                                                            Complaint Reason
                                                        </MenuItem>

                                                        <MenuItem
                                                            key="1"
                                                            value="1"
                                                        >
                                                            Transaction
                                                            Successful, account
                                                            not updated
                                                        </MenuItem>
                                                        <MenuItem
                                                            key="2"
                                                            value="2"
                                                        >
                                                            Amount deducted,
                                                            biller account
                                                            credited but
                                                            transaction ID not
                                                            received
                                                        </MenuItem>
                                                        <MenuItem
                                                            key="3"
                                                            value="3"
                                                        >
                                                            Amount deducted,
                                                            biller account not
                                                            credited &
                                                            transaction ID not
                                                            received
                                                        </MenuItem>
                                                        <MenuItem
                                                            key="4"
                                                            value="4"
                                                        >
                                                            Amount deducted
                                                            multiple times
                                                        </MenuItem>
                                                        <MenuItem
                                                            key="5"
                                                            value="5"
                                                        >
                                                            Double payment
                                                            updated
                                                        </MenuItem>
                                                        <MenuItem
                                                            key="6"
                                                            value="6"
                                                        >
                                                            Erroneously paid in
                                                            wrong account
                                                        </MenuItem>
                                                        <MenuItem
                                                            key="7"
                                                            value="7"
                                                        >
                                                            Others, provide
                                                            details in
                                                            description
                                                        </MenuItem>
                                                    </MaterialSelect>
                                                </Grid>

                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                    xl={12}
                                                >
                                                    <MaterialTextField
                                                        label="BBPS Transaction ID"
                                                        name="TransactionMasterID"
                                                        type="text"
                                                        length={150}
                                                        title="BBPS TransactionID"
                                                    />
                                                </Grid>

                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                    xl={12}
                                                >
                                                    <MaterialTextField
                                                        label="Description"
                                                        name="Description"
                                                        type="text"
                                                        length={150}
                                                        title="Description"
                                                    />
                                                </Grid>
                                            </Grid>

                                            <Divider
                                                variant="middle"
                                                className="rechdevider"
                                            />

                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                lg={12}
                                                spacing={2}
                                                container
                                            >
                                                <Grid container spacing={2}>
                                                    <Grid
                                                        item
                                                        sm={12}
                                                        md={12}
                                                        lg={6}
                                                        xl={6}
                                                    >
                                                        <PrimaryButton
                                                            type="submit"
                                                            title="Submit"
                                                            sx={{
                                                                marginTop: 3,
                                                                height: '50px',
                                                                textTransform:
                                                                    'none',
                                                                paddingX:
                                                                    '50px',
                                                                borderRadius:
                                                                    '4px'
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid
                                                        item
                                                        sm={12}
                                                        md={12}
                                                        lg={6}
                                                        xl={6}
                                                    >
                                                        <SecondaryButton
                                                            type="reset"
                                                            variant="contained"
                                                            color="secondary"
                                                            title="Reset"
                                                            sx={{
                                                                marginTop: 3,
                                                                height: '50px',
                                                                textTransform:
                                                                    'none',
                                                                paddingX:
                                                                    '50px',
                                                                borderRadius:
                                                                    '4px'
                                                            }}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Form>
                            </CustomContainer>
                        </Grid>
                    </Grid>
                </Paper>
            </>
        );
    };

    return (
        <Formik
            innerRef={formRef}
            enableReinitialize={true}
            initialValues={formObj}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            resetForm={formObj}
        >
            {TransferForm}
        </Formik>
    );
};
